module.exports = __webpack_public_path__ + "img/JOC_3674.a30db74f.webp";